"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * The default mime model implementation.
 */

var MimeModel = /*#__PURE__*/function () {
  /**
   * Construct a new mime model.
   */
  function MimeModel() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, MimeModel);

    this.trusted = !!options.trusted;
    this._data = options.data || {};
    this._metadata = options.metadata || {};
    this._callback = options.callback || Private.noOp;
  }
  /**
   * The data associated with the model.
   */


  _createClass(MimeModel, [{
    key: "setData",

    /**
     * Set the data associated with the model.
     *
     * #### Notes
     * Depending on the implementation of the mime model,
     * this call may or may not have deferred effects,
     */
    value: function setData(options) {
      this._data = options.data || this._data;
      this._metadata = options.metadata || this._metadata;

      this._callback(options);
    }
  }, {
    key: "data",
    get: function get() {
      return this._data;
    }
    /**
     * The metadata associated with the model.
     */

  }, {
    key: "metadata",
    get: function get() {
      return this._metadata;
    }
  }]);

  return MimeModel;
}();

exports.MimeModel = MimeModel;
/**
 * The namespace for module private data.
 */

var Private;

(function (Private) {
  /**
   * A no-op callback function.
   */
  function noOp() {
    /* no-op */
  }

  Private.noOp = noOp;
})(Private || (Private = {}));